import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  GetRequestsActionResponse,
  RequestAction,
} from '../entities/request-type.entity';
@Injectable()
export abstract class RequestsTypeServices {
  /**
   * All RequestsType
   */
  abstract getAllRequestsType(): Observable<GetRequestsActionResponse>;

  /**
   * Create RequestsType
   * @param requestType
   */
  abstract createRequestType(
    requestType: RequestAction
  ): Observable<GetRequestsActionResponse>;

  /**
   * Update RequestsType
   * @param requestType
   */
  abstract updateRequestType(
    id: string,
    action: string
  ): Observable<GetRequestsActionResponse>;

  /**
   * Delete RequestsType
   * @param requestTypeId
   */
  abstract deleteRequestType(requestTypeId: string): Observable<any>;

  /**
   * Request Actions By Company
   */
  abstract getRequestActionsByCompany(companyId: string): Observable<any>;

  /**
   * Change Requests Action Type
   */
  abstract changeRequestActionType(
    companyId: string,
    data: any
  ): Observable<any>;
}
